import * as React from 'react';
import createSvgIcon from '../../utils/createSvgIcon';

const DoubleArrowForward = createSvgIcon(
  <><path d="m8.4589 1.6038 10.284 10.396-10.284 10.396 1.5997 1.5823 11.849-11.979-11.849-11.978-1.5997 1.5823z" /><path d="m2.095 1.6038 10.284 10.396-10.284 10.396 1.5996 1.5823 11.849-11.979-11.849-11.978-1.5996 1.5823z" /></>,
  'DoubleArrowForward'
);

export { DoubleArrowForward };
